module.exports = __webpack_public_path__ + "static/media/rolletTransmitter.467c024b.jpg";